<div name="driver-event-confirmation-modal">
    <div class="modal-header">
        <div class="media d-flex align-items-center">
            <button class="btn btn-tertiary btn-min mr-3" aria-label="Close" (click)="close()">
                <i class="jr-icon close"></i>
            </button>
            <div class="media-body">
                <h4 class="modal-title" id="drawerModalLabel">
                    Passenger no show
                </h4>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <h2>Have you...?</h2>
        <ul>
            <li>
                Waited the agreed waiting time
            </li>
            <li>
                Made a reasonable attempt to contact the passenger
            </li>
            <li>
                Collected all required evidence in case of a dispute
            </li>
        </ul>

        <button class="btn btn-block btn-secondary" (click)="cancelEvent()">No, Cancel Notification</button>
        <button class="btn btn-block btn-destructive" (click)="confirmEvent()">Yes, Record No Show</button>
    </div>
</div>